export class ContraindicationsFormData {
    public id?: number | null;
    public contraindications: number | null;
    public indications: number | null;
    public contraindicationsService: number | null;
    public indicationsService: number | null;
    constructor() {
        this.contraindications = null;
        this.indications = null;
        this.contraindicationsService = null;
        this.indicationsService = null;
    }
}
